import { mutatorAction } from 'satcheljs';
export default mutatorAction('setTableIsInCheckedMode', function setTableIsInCheckedMode(tableView, isInCheckedMode) {
    tableView.isInCheckedMode = isInCheckedMode;
});
//# sourceMappingURL=setTableIsInCheckedMode.js.map